module.exports = __webpack_public_path__ + "static/media/energy-arrow.514fc56c.svg";